import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Proteção CSRF
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;

  if (!config) config = {};
  if (!config.headers) config.headers = {};
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  return originalFetch(resource, config);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
